import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, Ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  ConclusionStep,
  ContentDisplay,
  Heading,
  ListDisplay,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';


export default /*#__PURE__*/_defineComponent({
  __name: 'Conclusion',
  setup(__props) {

const router = useRouter();

const portfolioId = inject('portfolioCreatedId') as Ref<string>;
const portfolioName = inject('portfolioCreatedName') as Ref<string>;

const details = computed(() => {
  return [
    {
      label: 'Nome',
      value: portfolioName.value
    },
    {
      label: 'Tipo de gestão',
      value: 'Manual'
    }
  ];
});

function goToPortfolio() {
  router.push({
    name: 'wealthPortfolio',
    params: { id: portfolioId.value }
  });
}

function goToInvestment() {
  router.push({
    name: 'wealthProductTransaction',
    params: { id: portfolioId.value }
  });
}

return { __sfc: true,router, portfolioId, portfolioName, details, goToPortfolio, goToInvestment, ConclusionStep, ContentDisplay, Heading, ListDisplay, ButtonPrimary }
}

})